import httpClient from "./httpClient";

const base = "/testimonials";

export function saveTestimonial(payload) {
  return httpClient.post(base, payload).then((res) => res.data);
}

export function updateTestimonial(payload) {
  return httpClient.post(`${base}/update`, payload).then((res) => res.data);
}

export function listTestimonials(academicYear) {
  return httpClient.get(base, { params: { academicYear } }).then((res) => res.data.data);
}
